module.exports = __webpack_public_path__ + "img/WP2023-LBA.30dccc77.jpg";